import { VariableKeyBox } from "@/workflow/components/VariableKeyBox";
import { getOperationVerb } from "@/utils/format";

interface DataCenterOutputBlockProps {
  operation?: string;
  variableName?: string;
  variableType?: string;
}

export const DataCenterOutputBlock = ({
  operation,
  variableName,
  variableType,
}: DataCenterOutputBlockProps) => {
  if (operation && ["create", "update", "delete"].includes(operation)) {
    return (
      <>
        <VariableKeyBox
          name={`ids-registros-${getOperationVerb(operation)}`}
          type="array"
          key={`variable-array`}
        />
        <VariableKeyBox
          name={`cantidad-registros-${getOperationVerb(operation)}`}
          type="number"
          key={`variable-count`}
        />
      </>
    );
  }
  return <VariableKeyBox name={variableName ?? ""} type={variableType ?? ""} />;
};
